export default __webpack_public_path__ + "static/media/doctor.8668ab45.svg";